import React, { useMemo, useState, useEffect } from "react";

/* YAZTUR giriş ekranı sokak sahnesi — tamamen SVG + CSS animasyon.
   Koordinat sistemi 1009x900; panel boyutuna "slice" ile ölçeklenir. */

const CSS = `
@keyframes yzRight{from{transform:translateX(-260px)}to{transform:translateX(1260px)}}
@keyframes yzLeftStop{0%{transform:translateX(1260px)}50%{transform:translateX(180px)}55%{transform:translateX(115px)}67%{transform:translateX(115px);animation-timing-function:ease-in}100%{transform:translateX(-260px)}}
@keyframes yzSpin{to{transform:rotate(360deg)}}
@keyframes yzTwinkle{0%,100%{opacity:1}50%{opacity:.25}}
@keyframes yzBlink{0%,62%{opacity:1}66%,90%{opacity:.08}94%,100%{opacity:1}}
@keyframes yzOn{0%,55%{opacity:0}58%,86%{opacity:1}89%,100%{opacity:0}}
@keyframes yzDrift{from{transform:translateX(-60px)}to{transform:translateX(80px)}}
@keyframes yzR{0%,37.9%{opacity:.18}38%,56%{opacity:1}56.1%,100%{opacity:.18}}
@keyframes yzY{0%,34.9%{opacity:.18}35%,37.9%{opacity:1}38%,100%{opacity:.18}}
@keyframes yzG{0%,34.9%{opacity:1}35%,56%{opacity:.18}56.1%,100%{opacity:1}}
@keyframes yzBoard{0%{transform:translate(40px,0);opacity:0}5%{opacity:1}15%{transform:translate(150px,0)}68%{transform:translate(150px,0);opacity:1}80%{transform:translate(154px,22px);opacity:1}85%{transform:translate(154px,22px);opacity:0}100%{transform:translate(40px,0);opacity:0}}
@keyframes yzCross{0%,27%{transform:translate(720px,0);opacity:0}29%{opacity:1}39%,40%{transform:translate(612px,0)}54%{transform:translate(612px,-176px)}64%{transform:translate(530px,-176px);opacity:1}66%,100%{transform:translate(530px,-176px);opacity:0}}
@keyframes yzStep{from{transform:translateY(0)}to{transform:translateY(-1.5px)}}
@keyframes yzIdle{0%,100%{transform:translateY(0)}50%{transform:translateY(-1px)}}
.yz-scene .yz-veh{animation-duration:30s;animation-timing-function:linear;animation-iteration-count:infinite}
.yz-scene .yz-right{animation-name:yzRight}
.yz-scene .yz-left{animation-name:yzLeftStop}
.yz-scene .yz-wheel{transform-box:fill-box;transform-origin:center;animation:yzSpin 1.7s linear infinite}
.yz-scene .yz-star{animation:yzTwinkle 3.2s ease-in-out infinite}
.yz-scene .yz-blink{animation:yzBlink 9s linear infinite}
.yz-scene .yz-on{opacity:0;animation:yzOn 11s linear infinite}
.yz-scene .yz-cloud{animation:yzDrift 60s ease-in-out infinite alternate}
.yz-scene .yz-light-r{animation:yzR 30s linear infinite}
.yz-scene .yz-light-y{animation:yzY 30s linear infinite}
.yz-scene .yz-light-g{animation:yzG 30s linear infinite}
.yz-scene .yz-boarder{animation:yzBoard 10s linear infinite}
.yz-scene .yz-kid{animation:yzCross 30s linear infinite}
.yz-scene .yz-walk{animation:yzStep .32s ease-in-out infinite alternate}
.yz-scene .yz-idle{animation:yzIdle 2.6s ease-in-out infinite}
.yz-scene.yz-paused *{animation-play-state:paused !important}
@media (prefers-reduced-motion: reduce){
.yz-scene *{animation:none !important}
.yz-scene .yz-right{transform:translateX(120px)}
.yz-scene .yz-left{transform:translateX(700px)}
.yz-scene .yz-boarder{transform:translate(150px,0)}
.yz-scene .yz-kid{opacity:0}
.yz-scene .yz-on{opacity:0}
}
`;

const BUILDINGS = [[0,520,70],[66,490,60],[120,540,52],[168,470,64],[226,515,58],[424,500,56],[474,460,70],[538,525,54],[586,480,66],[646,510,60],[700,470,70],[770,500,62],[828,470,58],[882,520,56],[934,480,75]];
const STARS = [[60,150],[130,210],[250,130],[300,240],[420,170],[480,120],[560,230],[700,200],[90,300],[520,300],[380,90],[730,110],[800,160],[880,240],[960,140],[930,300]];

function rng(seed){ return function(){ seed |= 0; seed = seed + 0x6D2B79F5 | 0; let t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

function Windows(){
  const items = useMemo(() => {
    const r = rng(7); const out = [];
    BUILDINGS.forEach(([x, top, w], bi) => {
      out.push(<rect key={"b"+bi} x={x} y={top} width={w} height={640-top} fill="#171A1F" />);
      for (let yy = top + 14; yy < 620; yy += 24) {
        for (let xx = x + 8; xx < x + w - 12; xx += 18) {
          const v = r(); const k = bi + "-" + xx + "-" + yy;
          if (v < 0.35) {
            const blink = r() < 0.35;
            out.push(<rect key={k} className={blink ? "yz-blink" : undefined} x={xx} y={yy} width="10" height="12" rx="1" fill="#F5C518" fillOpacity="0.55"
              style={blink ? { animationDuration: (5 + r()*9).toFixed(1)+"s", animationDelay: "-"+(r()*14).toFixed(1)+"s" } : undefined} />);
          } else {
            out.push(<rect key={k} x={xx} y={yy} width="10" height="12" rx="1" fill="#0D0F12" />);
            if (r() < 0.18) out.push(<rect key={k+"on"} className="yz-on" x={xx} y={yy} width="10" height="12" rx="1" fill="#FFD66B" fillOpacity="0.6"
              style={{ animationDuration: (7 + r()*9).toFixed(1)+"s", animationDelay: "-"+(r()*16).toFixed(1)+"s" }} />);
          }
        }
      }
    });
    return out;
  }, []);
  return <g>{items}</g>;
}

const Tree = ({ x }) => (<g><rect x={x-4} y="600" width="8" height="40" fill="#2A2320" /><circle cx={x} cy="592" r="22" fill="#1E4A3A" /><circle cx={x-12} cy="604" r="14" fill="#1E4A3A" /><circle cx={x+12} cy="602" r="15" fill="#235843" /></g>);
const Lamp = ({ x }) => (<g><rect x={x-2} y="560" width="4" height="84" fill="#3A414C" /><rect x={x-2} y="560" width="22" height="4" fill="#3A414C" /><rect x={x+12} y="562" width="14" height="6" rx="2" fill="#FFE8A3" /><circle cx={x+19} cy="572" r="26" fill="#FFE8A3" fillOpacity="0.08" /></g>);

const Wheel = ({ cx, r = 12 }) => (
  <g className="yz-wheel"><circle cx={cx} cy="66" r={r} fill="#0D0F12" /><circle cx={cx} cy="66" r="6" fill="#C9CED6" />
    <rect x={cx-1.5} y="57" width="3" height="18" fill="#8A919C" /><rect x={cx-9} y="64.5" width="18" height="3" fill="#8A919C" /></g>
);

function BusBody(){
  return (<g>
    <ellipse cx="90" cy="78" rx="82" ry="4" fill="#000" fillOpacity="0.4" />
    <path d="M 176 54 L 250 42 L 250 70 Z" fill="#FFE8A3" fillOpacity="0.12" />
    <rect x="70" y="3" width="58" height="9" rx="3" fill="#DDE0E4" />
    <rect x="6" y="10" width="168" height="56" rx="10" fill="#F4F5F7" />
    <path d="M 6 48 H 174 V 58 Q 174 66 166 66 H 14 Q 6 66 6 58 Z" fill="#F2C318" />
    <rect x="6" y="45" width="168" height="4" fill="#B3B8BF" />
    <path d="M 24 66 A 16 16 0 0 1 56 66 Z" fill="#14161A" />
    <path d="M 122 66 A 16 16 0 0 1 154 66 Z" fill="#14161A" />
    <rect x="12" y="16" width="18" height="25" rx="3" fill="#1E2228" />
    <rect x="34" y="16" width="46" height="16" rx="2" fill="#0A0C0F" />
    <rect x="34" y="34" width="46" height="7" rx="2" fill="#1E2228" />
    <rect x="84" y="16" width="22" height="25" rx="3" fill="#1E2228" />
    <rect x="109" y="16" width="20" height="25" rx="3" fill="#1E2228" />
    <path d="M 87 19 L 93 19 L 89 37 L 85 37 Z" fill="#3A414C" />
    <rect x="132" y="15" width="13" height="48" rx="2" fill="#1E2228" stroke="#B3B8BF" strokeWidth="1" />
    <path d="M 147 12 H 160 Q 172 12 174 26 V 47 H 147 Z" fill="#14161A" />
    <path d="M 153 20 L 160 20 L 153 38 Z" fill="#3A414C" />
    <rect x="150" y="14" width="20" height="4" rx="1" fill="#FFB547" fillOpacity="0.9" />
    <circle cx="169" cy="55" r="3.5" fill="#FFE8A3" />
    <rect x="6" y="40" width="4" height="8" rx="1" fill="#FF5C5C" />
    <Wheel cx={40} /><Wheel cx={138} />
  </g>);
}

function Bus({ line, mirrored }){
  return (<g>
    {mirrored ? <g transform="translate(180 0) scale(-1 1)"><BusBody /></g> : <BusBody />}
    <text x={mirrored ? 123 : 57} y="28.5" textAnchor="middle" fontFamily="'JetBrains Mono', monospace" fontSize="12" fontWeight="700" fill="#FFB547">{line}</text>
  </g>);
}

function Car({ color, taxi }){
  return (<g>
    <ellipse cx="50" cy="47" rx="44" ry="3" fill="#000" fillOpacity="0.4" />
    <path d="M 98 32 L 150 24 L 150 42 Z" fill="#FFE8A3" fillOpacity="0.12" />
    <path d="M 6 36 V 28 Q 6 22 14 21 L 28 20 L 40 8 Q 42 6 46 6 H 66 Q 70 6 73 9 L 84 20 L 92 22 Q 98 24 98 30 V 36 Q 98 40 94 40 H 10 Q 6 40 6 36 Z" fill={color} />
    <path d="M 34 20 L 43 10 H 56 V 20 Z" fill="#1E2228" /><path d="M 60 10 H 68 L 78 20 H 60 Z" fill="#1E2228" />
    {taxi && <rect x="50" y="1" width="16" height="6" rx="1" fill="#14161A" />}
    <circle cx="95" cy="30" r="2.5" fill="#FFE8A3" /><rect x="6" y="27" width="3" height="5" rx="1" fill="#FF5C5C" />
    <g className="yz-wheel"><circle cx="26" cy="40" r="8" fill="#0D0F12" /><circle cx="26" cy="40" r="3.5" fill="#8A919C" /><rect x="25" y="33" width="2" height="14" fill="#3A414C" /></g>
    <g className="yz-wheel"><circle cx="80" cy="40" r="8" fill="#0D0F12" /><circle cx="80" cy="40" r="3.5" fill="#8A919C" /><rect x="79" y="33" width="2" height="14" fill="#3A414C" /></g>
  </g>);
}

function Person({ shirt, hair = "#2A2320", pants = "#2A2F37", skin = "#E8B894", bag }){
  return (<g>
    {bag && <rect x="10" y="10" width="5" height="9" rx="2" fill={bag} />}
    <rect x="4" y="19" width="3" height="11" rx="1.5" fill={pants} /><rect x="9" y="19" width="3" height="11" rx="1.5" fill={pants} />
    <rect x="3" y="9" width="10" height="12" rx="4" fill={shirt} />
    <circle cx="8" cy="5" r="4" fill={skin} /><path d="M 4 4.5 Q 8 -0.5 12 4.5 Q 8 2.5 4 4.5 Z" fill={hair} />
  </g>);
}

const FAR_BUSES = [["15B", 0], ["16A", -10], ["5A", -20]];
const NEAR_BUSES = [["15A", -6.75], ["16İ", -11.35], ["B1", -18.95]];
const TAXI_DELAY = -15.95;

export default function LoginStreetScene(){
  const [paused, setPaused] = useState(() => { try { return localStorage.getItem("yz-scene-paused") === "1"; } catch { return false; } });
  useEffect(() => { try { localStorage.setItem("yz-scene-paused", paused ? "1" : "0"); } catch {} }, [paused]);
  const d = (s) => ({ animationDelay: s + "s" });

  return (
    <div className={"yz-scene" + (paused ? " yz-paused" : "")} style={{ position: "absolute", inset: 0 }}>
      <style>{CSS}</style>
      <svg viewBox="0 0 1009 900" preserveAspectRatio="xMidYMax slice" width="100%" height="100%" aria-hidden="true" style={{ display: "block" }}>
        {STARS.map(([x, y], i) => <circle key={i} className="yz-star" cx={x} cy={y} r={i % 3 ? 1.6 : 2.2} fill="#ECEEF1" style={d((i * 0.7).toFixed(1))} />)}
        <circle cx="640" cy="130" r="28" fill="#ECEEF1" fillOpacity="0.92" /><circle cx="630" cy="124" r="5" fill="#C9CED6" /><circle cx="650" cy="140" r="4" fill="#C9CED6" />
        <g className="yz-cloud"><g fill="#1E2228"><ellipse cx="140" cy="250" rx="60" ry="16" /><ellipse cx="170" cy="238" rx="34" ry="16" /></g></g>
        <g className="yz-cloud" style={{ animationDuration: "80s", animationDelay: "-20s" }}><g fill="#1E2228"><ellipse cx="520" cy="200" rx="70" ry="15" /><ellipse cx="490" cy="190" rx="30" ry="14" /></g></g>
        <path d="M -20 560 L 120 440 L 200 480 L 360 320 L 470 410 L 540 370 L 700 470 L 850 410 L 1030 560 Z" fill="#161A20" />
        <path d="M 326 354 L 360 320 L 396 356 L 380 350 L 366 362 L 352 348 L 340 360 Z" fill="#3A414C" />
        <path d="M 522 386 L 540 370 L 560 386 L 548 384 L 540 392 L 532 384 Z" fill="#3A414C" />
        <path d="M 832 424 L 850 410 L 870 426 L 858 424 L 850 432 L 842 424 Z" fill="#3A414C" />
        <Windows />
        <g fill="#1A1E24">
          <rect x="292" y="560" width="116" height="80" /><path d="M 300 562 Q 350 492 400 562 Z" />
          <rect x="345" y="482" width="10" height="16" /><path d="M 350 470 L 356 484 L 344 484 Z" />
          <rect x="276" y="470" width="10" height="170" /><path d="M 281 440 L 288 472 L 274 472 Z" /><rect x="272" y="520" width="18" height="5" />
          <rect x="414" y="470" width="10" height="170" /><path d="M 419 440 L 426 472 L 412 472 Z" /><rect x="410" y="520" width="18" height="5" />
        </g>
        <g fill="#F5C518" fillOpacity="0.45"><rect x="316" y="590" width="10" height="16" rx="5" /><rect x="345" y="590" width="10" height="16" rx="5" /><rect x="374" y="590" width="10" height="16" rx="5" /></g>
        <rect x="0" y="636" width="1009" height="18" fill="#262B33" /><rect x="0" y="652" width="1009" height="4" fill="#3A414C" />
        <Tree x={40} /><Tree x={470} /><Tree x={720} /><Tree x={930} />
        <Lamp x={250} /><Lamp x={620} /><Lamp x={840} />
        <g>
          <rect x="100" y="586" width="110" height="6" rx="2" fill="#3A414C" />
          <rect x="104" y="592" width="4" height="46" fill="#3A414C" /><rect x="202" y="592" width="4" height="46" fill="#3A414C" />
          <rect x="110" y="596" width="90" height="30" fill="#5EC8FF" fillOpacity="0.08" />
          <rect x="120" y="624" width="70" height="5" rx="2" fill="#3A414C" />
          <rect x="222" y="572" width="4" height="66" fill="#8A919C" />
          <rect x="206" y="550" width="36" height="26" rx="4" fill="#2F6FD1" />
          <text x="224" y="567" textAnchor="middle" fontFamily="'Barlow Semi Condensed', sans-serif" fontSize="11" fontWeight="700" fill="#FFFFFF">DURAK</text>
        </g>
        <g>
          <rect x="358" y="590" width="4" height="48" fill="#8A919C" />
          <circle cx="360" cy="580" r="15" fill="#FFFFFF" /><circle cx="360" cy="580" r="15" fill="none" stroke="#E0363C" strokeWidth="4" />
          <text x="360" y="585" textAnchor="middle" fontFamily="'Barlow Semi Condensed', sans-serif" fontSize="14" fontWeight="700" fill="#14161A">50</text>
        </g>
        <g>
          <rect x="538" y="566" width="5" height="72" fill="#3A414C" />
          <rect x="530" y="520" width="21" height="52" rx="5" fill="#14161A" stroke="#3A414C" strokeWidth="2" />
          <circle className="yz-light-r" cx="540.5" cy="532" r="5.5" fill="#FF5C5C" />
          <circle className="yz-light-y" cx="540.5" cy="546" r="5.5" fill="#F5C518" />
          <circle className="yz-light-g" cx="540.5" cy="560" r="5.5" fill="#3DD68C" />
        </g>
        <g>
          <rect x="662" y="590" width="4" height="48" fill="#8A919C" />
          <path d="M 664 562 L 682 594 L 646 594 Z" fill="#FFFFFF" stroke="#E0363C" strokeWidth="3" strokeLinejoin="round" />
          <circle cx="664" cy="578" r="3" fill="#14161A" /><path d="M 664 581 L 664 588 M 660 590 L 664 588 L 668 590" stroke="#14161A" strokeWidth="2" fill="none" />
        </g>
        <rect x="0" y="656" width="1009" height="154" fill="#15181C" />
        <line x1="0" y1="733" x2="1009" y2="733" stroke="#F5C518" strokeOpacity="0.55" strokeWidth="3" strokeDasharray="30 22" />
        <g fill="#ECEEF1" fillOpacity="0.35"><rect x="584" y="662" width="10" height="142" /><rect x="602" y="662" width="10" height="142" /><rect x="620" y="662" width="10" height="142" /><rect x="638" y="662" width="10" height="142" /></g>
        <rect x="0" y="806" width="1009" height="4" fill="#3A414C" /><rect x="0" y="810" width="1009" height="22" fill="#262B33" />

        {/* Uzak şerit: sola giden, durakta duran otobüsler */}
        {FAR_BUSES.map(([line, delay]) => (
          <g key={line} transform="translate(0 640)">
            <g className="yz-veh yz-left" style={d(delay)}>
              <g transform="translate(0 11.76) scale(0.86)" style={{ filter: "brightness(0.85)" }}><Bus line={line} mirrored /></g>
            </g>
          </g>
        ))}
        {/* Yakın şerit: sağa giden araçlar */}
        <g transform="translate(0 742)"><g className="yz-veh yz-right" style={d(TAXI_DELAY)}><Car color="#F5C518" taxi /></g></g>
        {NEAR_BUSES.map(([line, delay]) => (
          <g key={line} transform="translate(0 708)"><g className="yz-veh yz-right" style={d(delay)}><Bus line={line} /></g></g>
        ))}

        {/* Durakta bekleyenler ve binen yolcu */}
        <g transform="translate(118 622)"><g className="yz-idle" style={d(-0.8)}><Person shirt="#5EC8FF" /></g></g>
        <g transform="translate(184 622)"><g className="yz-idle"><Person shirt="#C8434A" hair="#6B4A2F" /></g></g>
        <g transform="translate(0 622)"><g className="yz-boarder"><g className="yz-walk"><Person shirt="#3DD68C" hair="#14161A" /></g></g></g>

        {/* Yaya geçidinden geçen çocuklar */}
        <g transform="translate(0 808)"><g className="yz-kid"><g className="yz-walk"><g transform="scale(0.75)"><Person shirt="#FF8FB1" hair="#6B4A2F" bag="#8B9CFF" /></g></g></g></g>
        <g transform="translate(15 808)"><g className="yz-kid"><g className="yz-walk" style={d(-0.16)}><g transform="scale(0.72)"><Person shirt="#F5C518" hair="#14161A" bag="#FF7A1A" /></g></g></g></g>
      </svg>

      <button type="button" onClick={() => setPaused(p => !p)} aria-label={paused ? "Animasyonu başlat" : "Animasyonu durdur"} title={paused ? "Animasyonu başlat" : "Animasyonu durdur"}
        style={{ position: "absolute", right: 16, bottom: 16, width: 36, height: 36, borderRadius: 10, border: "1px solid #262B33", background: "rgba(17,20,24,0.85)", color: "#9BA3AE", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
        {paused
          ? <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>
          : <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>}
      </button>
    </div>
  );
}
